import { nth, pipe, split, startsWith } from 'ramda';
import { compact } from 'ramda-adjunct';

export enum TagPrefix {
  Favorites = '_fav',
  TransparentVideo = '_mp4_alpha',
  FileOrigin = '_fileOrigin',
  VideoSession = '_videosession',
  VideoMaker = '_videomaker',
  VimeoCreator = '_vimeo_videomaker',
  ShutterStock = '_shutterstock',
  Unsplash = '_unsplash',
  WixStock = '_wixstock',
  Edited = 'edited',
  Paid = '_paid',
  AdobeExpressProjectId = '_adobeExpress_project_id',
  Animated = '_animated',
}

export const isVideoSessionIdTag = startsWith(TagPrefix.VideoSession);

export const isFileOriginTag = startsWith(TagPrefix.FileOrigin);
export const extractSystemTagValueFromTag = pipe<string, string[], string[], string>(split('_'), compact, nth(1));
export const createFileOriginTag = (value: any) => `${TagPrefix.FileOrigin}_${String(value)}`;

export const isAdobeExpressProjectIdTag = startsWith(TagPrefix.AdobeExpressProjectId);
export const createAdobeExpressProjectIdTag = (projectId: string) => `${TagPrefix.AdobeExpressProjectId}_${projectId}`;
export const extractAdobeExpressProjectIdFromTag = (tag?: string) =>
  tag?.split(`${TagPrefix.AdobeExpressProjectId}_`)?.[1];
